export function generateRandomId() {
  const timestamp = new Date().getTime(); // Get current timestamp
  const randomValue = Math.random().toString(36).substring(2, 8); // Generate random alphanumeric string
  return `${timestamp}_${randomValue}`; // Combine timestamp and random value
}
